import React from 'react'
import { CloseButton as BsCloseButton } from 'react-bootstrap'
import styles from './styles.module.scss'

export const CloseButton = ({ onClick }: { onClick: (e: any) => void }) => {
  return <BsCloseButton onClick={onClick} className={styles.btnClose} title="Close" />
}
